module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_3009.d78c101e.png";